import scrollIndicator from "./scroll-indicator";
import setAnchorScroll from "./setAnchorScroll";

export default function common() {
  scrollIndicator();
  setAnchorScroll();
}
